<template>
<div :class="$options.name">
    <div :class="['content', portraitMode ? '-centered' : '-left-aligned']">
        <p class="paragraph">
            Born and raised in Italy, I moved to Melbourne in November 2012.
            In 2016 I started my career as web developer, working for Clemenger BBDO until December 2019.
        </p>
        <p class="paragraph">
            I am now pursuing opportunities for career advancement and I am available for full-time position or freelance work.
        </p>
    </div>
</div>
</template>
<script>
import gsap from 'gsap'
export default {
    name: 'about',
    data() {
        return {
            tl: false
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/app.scss';

.about {
    width: 100%;
    height: 100%;
    text-align: left;
    position: relative;
    .content {
        &.-centered {
            top: 60%;
            left: 50%;
            width: 80%;
            font-size: 4vw;
            position: absolute;
            transform: translateX(-50%);
            @include g-state(tablet) {
                font-size: 1.8rem;
            }
        }
        &.-left-aligned {
            top: 55%;
            width: 45%;
            left: 1rem;
            font-size: 3vh;
            position: absolute;
            transform: translateY(-50%);
            @include g-state(tablet) {
                width: 40%;
            }
        }
    }
}
</style>